package com.patronat.top.client.presentation.saved

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import org.koin.compose.koinInject

@Composable
fun ClientSavedRoute(
    onVenueDetailsRequested: (String) -> Unit
) {
    val viewModel: ClientSavedViewModel = koinInject()
    val state by viewModel.viewState.collectAsState()

    LaunchedEffect(viewModel) {
        viewModel.onEvent(ClientSavedEvent.OnRefresh)
    }

    LaunchedEffect(viewModel) {
        viewModel.effect.collect { effect ->
            when (effect) {
                is ClientSavedEffect.OpenVenueDetails -> onVenueDetailsRequested(effect.venueId)
            }
        }
    }

    ClientSavedScreen(
        state = state,
        onEvent = viewModel::onEvent
    )
}
